import React from "react";

export const FormTextArea = ({
  register,
  error,
  label,
  id,
  isRequired,
  ...inputProps
}) => {
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <textarea
        {...register(id, { required: isRequired })}
        className="form-control"
        id={id}
        {...inputProps}
      />
      {error && (
        <small className="text-danger form-text">Campo Obligatorio.</small>
      )}
    </div>
  );
};

export default FormTextArea;
